/**
 * True only when the backend has advertised Way purchase lookup for this location.
 * Unknown / missing → false (do not call the API until capability is known).
 */
export function isWayPurchaseLookupEnabled(
  location: { way_purchase_lookup_enabled?: boolean | null } | null | undefined
): boolean {
  return location?.way_purchase_lookup_enabled === true;
}
